/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import ReactDOM from "react-dom";

const overlayStyle = (isOpen) => css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  opacity: ${isOpen ? 1 : 1};
  pointer-events: ${isOpen ? "auto" : "none"};
  transition: opacity 0.3s ease;
  z-index: 9999;
`;

const drawerStyle = (isOpen) => css`
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  height: 100%;
  background: #fff;
  transform: translateX(${isOpen ? "0" : "100%"});
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
`;

const headerStyle = css`
  display: flex;
  justify-content: flex-end;
  padding: 12px;
  background: #f5f5f5;
`;

const iframeStyle = css`
  flex: 1;
  border: none;
`;

const buttonStyles =css`
  border: none;
  font-size: 25px;
   flex: 1;
  text-align:left;
  background:none;
`;

export default function AccessibilityModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div css={overlayStyle(isOpen)} onClick={onClose}>
      <div css={drawerStyle(isOpen)} onClick={(e) => e.stopPropagation()}>
        <div css={headerStyle}>
          <button onClick={onClose} css={buttonStyles}>X</button>
        </div>
        <iframe
          src="https://www.olympus-riviera.gr/embed/map"
          title="Accessibility Points"
          css={iframeStyle}
        />
      </div>
    </div>,
    document.body
  );
}
